module.exports = __webpack_public_path__ + "img/industry_graph.198de99c.png";